export default __webpack_public_path__ + "static/media/icon-20-icn-outsidet-the-corridor.c9e8449f.svg";